import React from 'react'
import FoodCategoryTable from './FoodCategoryTable'

const FoodCategory = () => {
  return (
    <div>
      <FoodCategoryTable/>
    </div>
  )
}

export default FoodCategory
